import classNames from 'classnames'

import { EMPTY_OBJECT } from '../../../../../constants/common'
import {
  isEventTargetSelf,
  isMainMouseButton,
} from '../../../../../utils/events'
import { BUTTON_HEIGHT_20 } from '../../../../Button'
import { DragDropDroppableArea } from '../../../../DragDrop'
import { getCalendarGridDropAreaId } from '../../../CalendarGrid.utils'
import { CalendarGridDayChips } from '../../../CalendarGridDayChips'
import { getIsCalendarGridTodayTinted } from '../../CalendarGridWeek.utils'

import {
  getCalendarGridSingleDayItems,
  getCalendarGridWeekAllDayCellStyle,
  getIsCalendarGridLaneItemDragDisabled,
  getIsCalendarGridWeekAllDayCellSelectable,
} from './CalendarGridWeekAllDayCell.utils'

import * as styles from './CalendarGridWeekAllDayCell.module.css'

function CalendarGridWeekAllDayCell({
  canMoveItems,
  className = styles.CalendarGridWeekAllDayCell,
  day,
  dayIndex,
  dayLoad,
  days,
  isSelected,
  isSkeleton,
  items,
  spanCount,
  today,
  onClickItem,
  onClickSecondaryLabel,
  onPointerDown,
  onPointerEnter,
}) {
  const { laneLabel } = dayLoad ?? EMPTY_OBJECT

  const isSelectable = getIsCalendarGridWeekAllDayCellSelectable({
    day,
    today,
    onPointerDown,
  })

  // Only the cell's own empty area starts a selection, never a chip on it
  function handlePointerDown(event) {
    if (isSelectable && isMainMouseButton(event) && isEventTargetSelf(event)) {
      onPointerDown(dayIndex)
    }
  }

  function handlePointerEnter() {
    if (isSelectable && onPointerEnter) {
      onPointerEnter(dayIndex)
    }
  }

  return (
    <DragDropDroppableArea
      className={classNames(className, {
        [styles.selectable]: isSelectable,
        [styles.selected]: isSelected,
        [styles.today]: getIsCalendarGridTodayTinted({ day, days, today }),
      })}
      data={{ day: day.date }}
      disabled={!canMoveItems}
      id={getCalendarGridDropAreaId(day.date)}
      style={getCalendarGridWeekAllDayCellStyle({ dayIndex, spanCount })}
      onPointerDown={handlePointerDown}
      onPointerEnter={handlePointerEnter}
    >
      <CalendarGridDayChips
        canMoveItems={canMoveItems}
        chipItems={getCalendarGridSingleDayItems(items)}
        day={day.date}
        dayLoad={dayLoad}
        dayLoadLabel={laneLabel}
        getIsItemDragDisabled={getIsCalendarGridLaneItemDragDisabled}
        isSkeleton={isSkeleton}
        items={items}
        moreHeight={BUTTON_HEIGHT_20}
        spanCount={spanCount}
        onClickItem={onClickItem}
        onClickSecondaryLabel={onClickSecondaryLabel}
      />
    </DragDropDroppableArea>
  )
}

export default CalendarGridWeekAllDayCell
